<script>
  export let isAnimated = true;
</script>

<div class="skeleton-image {isAnimated ? 'animated' : ''} rounded">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-image" viewBox="0 0 16 16">
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
    <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
  </svg>
</div>

<style lang="scss">
	.skeleton-image {
    background: #e9ecef;
		min-width: 135px;
    max-width: 135px;
    margin-right: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		overflow: hidden;

		@media (min-width: 576px) {
      min-width: 220px;
			min-height: 181px;
      margin-right: 40px;
    }

		svg {
			width: 23px;
			height: 23px;
			color: grey;
			z-index: 2;
			position: absolute;

			@media (min-width: 576px) {
				width: 35px;
				height: 35px;
			}
		}
  }

  .skeleton-image.animated {
    &:before {
			content: '';
			display: block;
			position: absolute;
			left: -150px;
			top: 0;
			height: 100%;
			width: 150px;
			background: linear-gradient(to right, transparent 0%, #fff 50%, transparent 100%);
			animation: load 2.2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
			z-index: 1;
		}
  }

	@keyframes load {
    from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
	}
</style>